<template>
  <modal :visible="modalVisible"
         header-has-border
         class="specs-modal"
         @modal-close="$emit('close')">
    <div slot="header" class="specs-header">
      <h2 class="title"><span class="brand">{{ deviceBrand }}</span> {{ deviceName }}</h2>
    </div>
    <div slot="body" class="specs-body">
      <div class="specs-image">
        <img :src="deviceImage" :alt="deviceName">
      </div>
      <div class="specs-text">
        <h5 class="section-title">{{ $t('checkout.cartOverview.specificationLabel') }}:</h5>
        <div v-for="spec in deviceSpecification" :key="spec.code" class="specs-text-row">
          <h6 class="title">{{ spec.name }}</h6>
          <div>
            <p v-for="feature in spec.features"
               :key="feature.code"
               class="description">
              {{ feature.name }}:
              <template v-if="feature.featureValues">
                <span v-for="(val, idx) in feature.featureValues" :key="val.value">
                  {{ val.value }}<template v-if="feature.featureUnit"> {{ feature.featureUnit.symbol }} </template><template
                  v-if="idx < feature.featureValues.length - 1">,</template>
                </span>
              </template>
            </p>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../common/modal/modal'

export default {
  name: 'product-specs-modal',
  components: { Modal },
  props: {
    modalVisible: Boolean,
    deviceInfo: {
      type: Object,
      default: () => ({})
    },
    specificationProp: {
      type: String,
      default: 'classifications'
    }
  },
  computed: {
    deviceSpecification () {
      return this.$props.deviceInfo[this.$props.specificationProp] || []
    },
    deviceBrand () {
      return this.$props.deviceInfo.brands && this.$props.deviceInfo.brands[0].name
    },
    deviceName () {
      return this.$props.deviceInfo.name
    },
    deviceImage () {
      return this.$props.deviceInfo.images && this.$props.deviceInfo.images[0].url
    }
  }
}
</script>

<style scoped lang="scss">
.specs-modal {
  overflow-y: auto;

  /deep/ .custom-modal__container {
    padding: 2.4rem;
  }
}

.specs-header {
  flex: 1 1 auto;

  /deep/ + button.base-button {
    align-self: flex-start;

    @media (map_get($breakpoints, sm)) {
      padding: 0 !important;
      align-self: auto;
    }
  }

  .title {
    font-size: 1.6rem;
    margin: 2.4rem 0 0;
    font-weight: normal;
    text-transform: uppercase;
    text-align: center;

    @media (map_get($breakpoints, sm)) {
      text-align: left;
      font-size: 2rem;
      margin: 0;
    }

    .brand {
      font-weight: 600;
      display: block;

      @media (map_get($breakpoints, sm)) {
        display: inline;
        margin-right: 1.5rem;
      }
    }
  }
}

.specs-body {
  padding: 1.6rem 0;
  display: flex;
  flex-direction: column;

  @media (map_get($breakpoints, sm)) {
    flex-direction: row;
  }

  .specs-image {
    text-align: center;
    flex: 1 1 33%;

    @media (map_get($breakpoints, sm)) {
      order: 1;
    }

    img {
      width: 100%;
      max-width: 16rem;
      height: auto;

      @media (map_get($breakpoints, sm)) {
        max-width: 33rem;
      }
    }
  }

  .specs-text {
    flex: 1 1 67%;
    padding: 2.4rem 0 0;
    color: $text;

    @media (map_get($breakpoints, sm)) {
      padding-top: 0;
    }

    .section-title {
      display: none;

      @media (map_get($breakpoints, sm)) {
        display: block;
        font-size: 1.6rem;
        margin-bottom: 1.6rem;
      }
    }
  }

  .specs-text-row {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 0.8rem;

    @media (map_get($breakpoints, sm)) {
      flex-direction: row;
      text-align: left;
    }

    .title {
      font-size: 1.4rem;
      font-weight: 600;
      margin: 0;

      @media (map_get($breakpoints, sm)) {
        flex: 1 1 200px;
        max-width: 200px;
        font-size: 1.6rem;
        font-weight: normal;
      }
    }

    > div {
      @media (map_get($breakpoints, sm)) {
        flex: 1 1 auto;
        margin-left: 2.4rem;
      }
    }

    .description {
      font-size: 1.4rem;
      margin: 0;
      color: $text-alt;

      @media (map_get($breakpoints, sm)) {
        font-size: 1.6rem;
        color: $text;
      }
    }
  }
}
</style>
